/**
 * Enumeravel usado para restringir o acesso do usuário do sistema EPC a partir da situacao
 */
export enum SituacaoRestrictEnumEPC {
    'Não é possível editar, pois o registro selecionado foi enviado e está aguardando entrega de documentação fisica.' = 3,
    'Não é possível editar, pois o registro selecionado já está aguardando análise no CRC - Gestor' = 4,
    'Não é possível editar, pois o registro selecionado já está em análise no CRC - Gestor.' = 5,
    'Não é possível editar, pois o registro selecionado já está aguardando julgamento no CRC - Comissão.' = 6,
    'Não é possível editar, pois o registro selecionado já está em julgamento no CRC - Comissão.' = 7,
    'Não é possível editar, pois o registro selecionado já está aguardando análise no CFC - Gestor.' = 8,
    'Não é possível editar, pois o registro selecionado já está em análise no CFC - Gestor.' = 9,
    'Não é possível editar, pois o registro selecionado já está aguardando julgamento no CFC - Comissão.' = 10,
    'Não é possível editar, pois o registro selecionado já está em julgamento no CFC - Comissão.' = 11,
    'Não é possível editar, pois o registro selecionado já está deferido.' = 12,
    'Não é possível excluir, pois o registro selecionado já está com processo finalizado.' = 15,
    'Não é possível editar, pois o registro selecionado se encontra com status de autorizado.' = 18
};
export enum Situacao2RestrictEnumEPC {
    'Devolvido para adequação' = 13,
    'Aberto para recurso' = 14,
    'Iniciado' = 16
};
/**
 * Enumeravel usado para restringir o acesso do usuário
 */
export enum AlterSituacaoEnum {
    Ativo = 1,
    Inativo = 2
}
/**
 * Enumeravel usado para restringir o acesso do usuário do sistema Registro a partir da situacao
 */
export enum SituacaoRestricEnumRegistro { }
/**
 * Enumeravel usado para restringir o acesso do usuário do sistema EPC a partir do peril
 */
export enum PerfilRestrictEnumEPC {
    'Não é possível editar, para editar a Situação deve ser igual a Iniciada.' = 'Profissional',
    '' = 'Gestor CRC'
}
/**
 * Enumeravel usado para restringir o acesso do usuário do sistema Registro a partir do peril
 */
export enum PerfilRestrictEnumRegistro { }
/**
 * Enumeravel usado para restringir o acesso do usuario do sistema Arrecadação
 */
export enum SituacaoRestrictEnumArrecadacao{
    Inativo = 1,
    Ativo = 2,
    "Em Análise" = 3,
    Autorizado = 4
};

/**
 * Enumeration padrao, usada somente para evitar erros ao aplicar alguma variavel sem enum.
 */
export enum EnumPadrao{}


// WEBPACK FOOTER //
// ./src/app/base/use-system/enums/Enumarations.ts